import {
	IonButton,
	IonContent,
	IonFooter,
	IonIcon,
	IonItem,
	IonList,
	IonModal,
	IonRadio,
	IonRadioGroup,
} from "@ionic/react";
import { useState } from "react";
import { useSettings } from "../../store/settings";
import { isNil } from "ramda";
import { checkmark } from "ionicons/icons";
import i18n from "../../i18n";

import "/node_modules/flag-icons/css/flag-icons.min.css";
import "./styles.css";

const LanguagesModal = () => {
	const { settings, updateSettings } = useSettings();

	const [selectedLanguage, setSelectedLanguage] = useState(null);

	const visible = isNil(settings.lang);

	const handleLanguageChange = (e) =>
		setSelectedLanguage(e.currentTarget.value);

	const handleSubmit = () => {
		updateSettings({ ...settings, lang: selectedLanguage });
		i18n.changeLanguage(selectedLanguage!);
	};

	return (
		<IonModal isOpen={visible}>
			<IonContent>
				<IonList style={{ marginTop: 40 }}>
					<IonRadioGroup
						value={selectedLanguage}
						onIonChange={handleLanguageChange}
					>
						<IonItem>
							<IonRadio slot="end" value="es"></IonRadio>
							<div className="lang-item">
								<span className="fi fi-es"></span>
								<p>Español</p>
							</div>
						</IonItem>
						<IonItem>
							<IonRadio slot="end" value="en"></IonRadio>
							<div className="lang-item">
								<span className="fi fi-gb"></span>
								<p>English</p>
							</div>
						</IonItem>
						<IonItem>
							<IonRadio slot="end" value="fr"></IonRadio>
							<div className="lang-item">
								<span className="fi fi-fr"></span>
								<p>Français</p>
							</div>
						</IonItem>
						<IonItem>
							<IonRadio slot="end" value="it"></IonRadio>
							<div className="lang-item">
								<span className="fi fi-it"></span>
								<p>Italiano</p>
							</div>
						</IonItem>
						<IonItem>
							<IonRadio slot="end" value="pt"></IonRadio>
							<div className="lang-item">
								<span className="fi fi-pt"></span>
								<p>Português</p>
							</div>
						</IonItem>
					</IonRadioGroup>
				</IonList>
			</IonContent>
			{selectedLanguage && (
				<IonFooter>
					<IonButton expand="block" onClick={handleSubmit}>
						<IonIcon slot="icon-only" icon={checkmark}></IonIcon>
					</IonButton>
				</IonFooter>
			)}
		</IonModal>
	);
};

export default LanguagesModal;
